/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteApiRuntimeCronJobsCronJobIdParams,
  GetApiRuntimeCronJobsCronJobIdParams,
  GetApiRuntimeCronJobsCronJobIdRunsParams,
  GetApiRuntimeCronJobsParams,
  ListCronRunsBodyRequest,
  OkResponse,
  RuntimeCronJobDeleteRequest,
  RuntimeCronJobRecordDto,
  RuntimeCronJobsListRequest,
  RuntimeCronRunRecordDto,
  RuntimeCronRunUpsertRequest,
  RuntimeCronRunsListRequest,
  RuntimeCronRunsPageDto,
  SaveCronJobRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiRuntimeCronJobsUrl = (params?: GetApiRuntimeCronJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runtime-cron-jobs?${stringifiedParams}` : `/api/runtime-cron-jobs`
}

export const getApiRuntimeCronJobs = async (params?: GetApiRuntimeCronJobsParams, options?: RequestInit): Promise<RuntimeCronJobRecordDto[]> => {

  return orvalControlFetch<RuntimeCronJobRecordDto[]>(getGetApiRuntimeCronJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiRuntimeCronJobsQueryKey = (params?: GetApiRuntimeCronJobsParams,) => {
    return [
    `/api/runtime-cron-jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiRuntimeCronJobsQueryOptions = <TData = Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError = unknown>(params?: GetApiRuntimeCronJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRuntimeCronJobsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>> = ({ signal }) => getApiRuntimeCronJobs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiRuntimeCronJobsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>>
export type GetApiRuntimeCronJobsQueryError = unknown


export function useGetApiRuntimeCronJobs<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError = unknown>(
 params: undefined |  GetApiRuntimeCronJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeCronJobs>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeCronJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeCronJobs<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError = unknown>(
 params?: GetApiRuntimeCronJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeCronJobs>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeCronJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeCronJobs<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError = unknown>(
 params?: GetApiRuntimeCronJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiRuntimeCronJobs<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError = unknown>(
 params?: GetApiRuntimeCronJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobs>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiRuntimeCronJobsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiRuntimeCronJobsUrl = () => {




  return `/api/runtime-cron-jobs`
}

export const postApiRuntimeCronJobs = async (saveCronJobRequest: SaveCronJobRequest, options?: RequestInit): Promise<RuntimeCronJobRecordDto> => {

  return orvalControlFetch<RuntimeCronJobRecordDto>(getPostApiRuntimeCronJobsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveCronJobRequest,)
  }
);}




export const getPostApiRuntimeCronJobsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeCronJobs>>, TError,{data: SaveCronJobRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeCronJobs>>, TError,{data: SaveCronJobRequest}, TContext> => {

const mutationKey = ['postApiRuntimeCronJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeCronJobs>>, {data: SaveCronJobRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeCronJobs(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeCronJobsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeCronJobs>>>
    export type PostApiRuntimeCronJobsMutationBody = SaveCronJobRequest
    export type PostApiRuntimeCronJobsMutationError = unknown

    export const usePostApiRuntimeCronJobs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeCronJobs>>, TError,{data: SaveCronJobRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeCronJobs>>,
        TError,
        {data: SaveCronJobRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeCronJobsMutationOptions(options), queryClient);
    }
    export const getGetApiRuntimeCronJobsCronJobIdUrl = (cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runtime-cron-jobs/${cronJobId}?${stringifiedParams}` : `/api/runtime-cron-jobs/${cronJobId}`
}

export const getApiRuntimeCronJobsCronJobId = async (cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdParams, options?: RequestInit): Promise<RuntimeCronJobRecordDto> => {

  return orvalControlFetch<RuntimeCronJobRecordDto>(getGetApiRuntimeCronJobsCronJobIdUrl(cronJobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiRuntimeCronJobsCronJobIdQueryKey = (cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdParams,) => {
    return [
    `/api/runtime-cron-jobs/${cronJobId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiRuntimeCronJobsCronJobIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError = unknown>(cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRuntimeCronJobsCronJobIdQueryKey(cronJobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>> = ({ signal }) => getApiRuntimeCronJobsCronJobId(cronJobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cronJobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiRuntimeCronJobsCronJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>>
export type GetApiRuntimeCronJobsCronJobIdQueryError = unknown


export function useGetApiRuntimeCronJobsCronJobId<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError = unknown>(
 cronJobId: string,
    params: undefined |  GetApiRuntimeCronJobsCronJobIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeCronJobsCronJobId<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError = unknown>(
 cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeCronJobsCronJobId<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError = unknown>(
 cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiRuntimeCronJobsCronJobId<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError = unknown>(
 cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiRuntimeCronJobsCronJobIdQueryOptions(cronJobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiRuntimeCronJobsCronJobIdUrl = (cronJobId: string,
    params?: DeleteApiRuntimeCronJobsCronJobIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runtime-cron-jobs/${cronJobId}?${stringifiedParams}` : `/api/runtime-cron-jobs/${cronJobId}`
}

export const deleteApiRuntimeCronJobsCronJobId = async (cronJobId: string,
    params?: DeleteApiRuntimeCronJobsCronJobIdParams, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiRuntimeCronJobsCronJobIdUrl(cronJobId,params),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiRuntimeCronJobsCronJobIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiRuntimeCronJobsCronJobId>>, TError,{cronJobId: string;params?: DeleteApiRuntimeCronJobsCronJobIdParams}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiRuntimeCronJobsCronJobId>>, TError,{cronJobId: string;params?: DeleteApiRuntimeCronJobsCronJobIdParams}, TContext> => {

const mutationKey = ['deleteApiRuntimeCronJobsCronJobId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiRuntimeCronJobsCronJobId>>, {cronJobId: string;params?: DeleteApiRuntimeCronJobsCronJobIdParams}> = (props) => {
          const {cronJobId,params} = props ?? {};

          return  deleteApiRuntimeCronJobsCronJobId(cronJobId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiRuntimeCronJobsCronJobIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiRuntimeCronJobsCronJobId>>>

    export type DeleteApiRuntimeCronJobsCronJobIdMutationError = unknown

    export const useDeleteApiRuntimeCronJobsCronJobId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiRuntimeCronJobsCronJobId>>, TError,{cronJobId: string;params?: DeleteApiRuntimeCronJobsCronJobIdParams}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiRuntimeCronJobsCronJobId>>,
        TError,
        {cronJobId: string;params?: DeleteApiRuntimeCronJobsCronJobIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiRuntimeCronJobsCronJobIdMutationOptions(options), queryClient);
    }
    export const getGetApiRuntimeCronJobsCronJobIdRunsUrl = (cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/runtime-cron-jobs/${cronJobId}/runs?${stringifiedParams}` : `/api/runtime-cron-jobs/${cronJobId}/runs`
}

export const getApiRuntimeCronJobsCronJobIdRuns = async (cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdRunsParams, options?: RequestInit): Promise<RuntimeCronRunRecordDto[]> => {

  return orvalControlFetch<RuntimeCronRunRecordDto[]>(getGetApiRuntimeCronJobsCronJobIdRunsUrl(cronJobId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiRuntimeCronJobsCronJobIdRunsQueryKey = (cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdRunsParams,) => {
    return [
    `/api/runtime-cron-jobs/${cronJobId}/runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiRuntimeCronJobsCronJobIdRunsQueryOptions = <TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError = unknown>(cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRuntimeCronJobsCronJobIdRunsQueryKey(cronJobId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>> = ({ signal }) => getApiRuntimeCronJobsCronJobIdRuns(cronJobId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(cronJobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiRuntimeCronJobsCronJobIdRunsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>>
export type GetApiRuntimeCronJobsCronJobIdRunsQueryError = unknown


export function useGetApiRuntimeCronJobsCronJobIdRuns<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError = unknown>(
 cronJobId: string,
    params: undefined |  GetApiRuntimeCronJobsCronJobIdRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeCronJobsCronJobIdRuns<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError = unknown>(
 cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>,
          TError,
          Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRuntimeCronJobsCronJobIdRuns<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError = unknown>(
 cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiRuntimeCronJobsCronJobIdRuns<TData = Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError = unknown>(
 cronJobId: string,
    params?: GetApiRuntimeCronJobsCronJobIdRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRuntimeCronJobsCronJobIdRuns>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiRuntimeCronJobsCronJobIdRunsQueryOptions(cronJobId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPostApiRuntimeCronJobsRunsUrl = () => {




  return `/api/runtime-cron-jobs/runs`
}

export const postApiRuntimeCronJobsRuns = async (listCronRunsBodyRequest: ListCronRunsBodyRequest, options?: RequestInit): Promise<RuntimeCronRunRecordDto[]> => {

  return orvalControlFetch<RuntimeCronRunRecordDto[]>(getPostApiRuntimeCronJobsRunsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      listCronRunsBodyRequest,)
  }
);}




export const getPostApiRuntimeCronJobsRunsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeCronJobsRuns>>, TError,{data: ListCronRunsBodyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeCronJobsRuns>>, TError,{data: ListCronRunsBodyRequest}, TContext> => {

const mutationKey = ['postApiRuntimeCronJobsRuns'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeCronJobsRuns>>, {data: ListCronRunsBodyRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeCronJobsRuns(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeCronJobsRunsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeCronJobsRuns>>>
    export type PostApiRuntimeCronJobsRunsMutationBody = ListCronRunsBodyRequest
    export type PostApiRuntimeCronJobsRunsMutationError = unknown

    export const usePostApiRuntimeCronJobsRuns = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeCronJobsRuns>>, TError,{data: ListCronRunsBodyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeCronJobsRuns>>,
        TError,
        {data: ListCronRunsBodyRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeCronJobsRunsMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeStateCronJobsListUrl = () => {




  return `/api/runtime-state/cron/jobs/list`
}

export const postApiRuntimeStateCronJobsList = async (runtimeCronJobsListRequest: RuntimeCronJobsListRequest, options?: RequestInit): Promise<RuntimeCronJobRecordDto[]> => {

  return orvalControlFetch<RuntimeCronJobRecordDto[]>(getPostApiRuntimeStateCronJobsListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeCronJobsListRequest,)
  }
);}




export const getPostApiRuntimeStateCronJobsListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobsList>>, TError,{data: RuntimeCronJobsListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobsList>>, TError,{data: RuntimeCronJobsListRequest}, TContext> => {

const mutationKey = ['postApiRuntimeStateCronJobsList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeStateCronJobsList>>, {data: RuntimeCronJobsListRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeStateCronJobsList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeStateCronJobsListMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeStateCronJobsList>>>
    export type PostApiRuntimeStateCronJobsListMutationBody = RuntimeCronJobsListRequest
    export type PostApiRuntimeStateCronJobsListMutationError = unknown

    export const usePostApiRuntimeStateCronJobsList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobsList>>, TError,{data: RuntimeCronJobsListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeStateCronJobsList>>,
        TError,
        {data: RuntimeCronJobsListRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeStateCronJobsListMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeStateCronJobUpsertUrl = () => {




  return `/api/runtime-state/cron/job/upsert`
}

export const postApiRuntimeStateCronJobUpsert = async (saveCronJobRequest: SaveCronJobRequest, options?: RequestInit): Promise<RuntimeCronJobRecordDto> => {

  return orvalControlFetch<RuntimeCronJobRecordDto>(getPostApiRuntimeStateCronJobUpsertUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveCronJobRequest,)
  }
);}




export const getPostApiRuntimeStateCronJobUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobUpsert>>, TError,{data: SaveCronJobRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobUpsert>>, TError,{data: SaveCronJobRequest}, TContext> => {

const mutationKey = ['postApiRuntimeStateCronJobUpsert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeStateCronJobUpsert>>, {data: SaveCronJobRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeStateCronJobUpsert(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeStateCronJobUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeStateCronJobUpsert>>>
    export type PostApiRuntimeStateCronJobUpsertMutationBody = SaveCronJobRequest
    export type PostApiRuntimeStateCronJobUpsertMutationError = unknown

    export const usePostApiRuntimeStateCronJobUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobUpsert>>, TError,{data: SaveCronJobRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeStateCronJobUpsert>>,
        TError,
        {data: SaveCronJobRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeStateCronJobUpsertMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeStateCronJobDeleteUrl = () => {




  return `/api/runtime-state/cron/job/delete`
}

export const postApiRuntimeStateCronJobDelete = async (runtimeCronJobDeleteRequest: RuntimeCronJobDeleteRequest, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getPostApiRuntimeStateCronJobDeleteUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeCronJobDeleteRequest,)
  }
);}




export const getPostApiRuntimeStateCronJobDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobDelete>>, TError,{data: RuntimeCronJobDeleteRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobDelete>>, TError,{data: RuntimeCronJobDeleteRequest}, TContext> => {

const mutationKey = ['postApiRuntimeStateCronJobDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeStateCronJobDelete>>, {data: RuntimeCronJobDeleteRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeStateCronJobDelete(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeStateCronJobDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeStateCronJobDelete>>>
    export type PostApiRuntimeStateCronJobDeleteMutationBody = RuntimeCronJobDeleteRequest
    export type PostApiRuntimeStateCronJobDeleteMutationError = unknown

    export const usePostApiRuntimeStateCronJobDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronJobDelete>>, TError,{data: RuntimeCronJobDeleteRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeStateCronJobDelete>>,
        TError,
        {data: RuntimeCronJobDeleteRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeStateCronJobDeleteMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeStateCronRunsListUrl = () => {




  return `/api/runtime-state/cron/runs/list`
}

export const postApiRuntimeStateCronRunsList = async (runtimeCronRunsListRequest: RuntimeCronRunsListRequest, options?: RequestInit): Promise<RuntimeCronRunsPageDto> => {

  return orvalControlFetch<RuntimeCronRunsPageDto>(getPostApiRuntimeStateCronRunsListUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeCronRunsListRequest,)
  }
);}




export const getPostApiRuntimeStateCronRunsListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronRunsList>>, TError,{data: RuntimeCronRunsListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronRunsList>>, TError,{data: RuntimeCronRunsListRequest}, TContext> => {

const mutationKey = ['postApiRuntimeStateCronRunsList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeStateCronRunsList>>, {data: RuntimeCronRunsListRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeStateCronRunsList(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeStateCronRunsListMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeStateCronRunsList>>>
    export type PostApiRuntimeStateCronRunsListMutationBody = RuntimeCronRunsListRequest
    export type PostApiRuntimeStateCronRunsListMutationError = unknown

    export const usePostApiRuntimeStateCronRunsList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronRunsList>>, TError,{data: RuntimeCronRunsListRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeStateCronRunsList>>,
        TError,
        {data: RuntimeCronRunsListRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeStateCronRunsListMutationOptions(options), queryClient);
    }
    export const getPostApiRuntimeStateCronRunUpsertUrl = () => {




  return `/api/runtime-state/cron/run/upsert`
}

export const postApiRuntimeStateCronRunUpsert = async (runtimeCronRunUpsertRequest: RuntimeCronRunUpsertRequest, options?: RequestInit): Promise<RuntimeCronRunRecordDto> => {

  return orvalControlFetch<RuntimeCronRunRecordDto>(getPostApiRuntimeStateCronRunUpsertUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      runtimeCronRunUpsertRequest,)
  }
);}




export const getPostApiRuntimeStateCronRunUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronRunUpsert>>, TError,{data: RuntimeCronRunUpsertRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronRunUpsert>>, TError,{data: RuntimeCronRunUpsertRequest}, TContext> => {

const mutationKey = ['postApiRuntimeStateCronRunUpsert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiRuntimeStateCronRunUpsert>>, {data: RuntimeCronRunUpsertRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiRuntimeStateCronRunUpsert(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiRuntimeStateCronRunUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof postApiRuntimeStateCronRunUpsert>>>
    export type PostApiRuntimeStateCronRunUpsertMutationBody = RuntimeCronRunUpsertRequest
    export type PostApiRuntimeStateCronRunUpsertMutationError = unknown

    export const usePostApiRuntimeStateCronRunUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiRuntimeStateCronRunUpsert>>, TError,{data: RuntimeCronRunUpsertRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiRuntimeStateCronRunUpsert>>,
        TError,
        {data: RuntimeCronRunUpsertRequest},
        TContext
      > => {
      return useMutation(getPostApiRuntimeStateCronRunUpsertMutationOptions(options), queryClient);
    }
